import multiiconbtn from "../icons/multiple_button_child";
import './parent';
import IconPicker from './icon-picker'

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText, InnerBlocks } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, ToggleControl, Card, CardBody, Dashicon, RangeControl, TabPanel, ColorIndicator, ColorPalette, Button } = wp.components;



registerBlockType('blocksbakery/innerbutton', {
    title: __('Multiple Button', 'blocks-bakery'),
    description: __(
        'This block allows you to style button', 'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'commmon',
    icon: multiiconbtn.multi_button_child,
    parent: ['blocksbakery/multibuttons'],
    keywords: [
        __('button', 'blocks-bakery'),
        __('text button', 'blocks-bakery')
    ],
    supports: {
        html: false
    },
    attributes: {
        icon_selector:
        {
            type:'string',
            default:'fas fa-window-close',
        },
        multibuttontext:{
            type:"string",
        },
        multibuttontext_val:{
            type:"string",
            default:'Click Here'
        }, 
        multibuttontext_href:{
            type:"string",
            default:"#"
        }
    },

    edit: (props) => {
     
    
      
    
        return [
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Button Styling')}>
                    <h2>Button Icon</h2>
                            <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}
                       
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                          />
                            <TextControl
                                label={__("Text", "blocks_bakery")}
                                value={props.attributes.multibuttontext_val}
                                onChange={(new_val) => {
                                    props.setAttributes({ multibuttontext_val: new_val })
                                }}
                            />

                            <TextControl
                                label={__("Link", "blocks_bakery")}
                                value={props.attributes.multibuttontext_href}
                                onChange={(new_val) => {
                                    props.setAttributes({ multibuttontext_href: new_val })
                                }}
                            />
                    </PanelBody>
                </InspectorControls>
                <div className="bb-multibuttons">
                    <div className="bb-multibuttons-wrapper">
                    <a href={props.attributes.multibuttontext_href} className="bb-button">
                        <span className="bb-button-wrapper">
                            <span className="bb-multibuttons-icon-left" className={props.attributes.icon_selector}></span>
                   
                       <RichText className="bb-multibuttons-text"
                       tagName="span"
                       value={props.attributes.multibuttontext_val}
                       onChange = {(new_val) =>{
                           props.setAttributes({multibuttontext:new_val})
                       }}
                       
                     />
                       </span>
                    </a>
                    </div>

                </div>
            </React.Fragment>
        ]

    },

    save: (props) => {
 
        return (
            <React.Fragment>
     <div className="bb-multibuttons">
                    <div className="bb-multibuttons-wrapper">
                    <a href={props.attributes.multibuttontext_href} className="bb-button">
                        <span className="bb-button-wrapper">
                            <span className="bb-multibuttons-icon-left" className={props.attributes.icon_selector}></span>
                   
                       <RichText.Content
                        className="bb-multibuttons-text"
                       tagName="span"
                       value={props.attributes.multibuttontext_val}
                       onChange = {(new_val) =>{
                           props.setAttributes({multibuttontext:new_val})
                       }}
                       
                     />
                       </span>
                    </a>
                    </div>

                </div>
            </React.Fragment>
       )
    }
})